import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    TibboDataType,
    ValidationMessage,
    SettingState,
    SettingOption,
} from '@appblocks/codegeneration/types';

export default class UnoWireSensorValue extends BaseFeature {
    constructor() {
        super();
        this.name = 'Sensor Value';
        this.id = 'unowiresensorval';

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                readonly: true,
                required: true,
                default: '',
            },
            {
                id: 'DESCRIPTION',
                name: 'Description',
                settingType: SettingType.STRING,
                readonly: true,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        return blocks;
    }
}
